import cx from 'classnames'
import { InputHTMLAttributes } from 'react'
import { useFormContext } from 'react-hook-form'

import { FormErrorMessage } from './ErrorMessage'

interface TextAreaProps {
  name: string
  className?: string
  disabled?: boolean
  placeholder?: string
  inputProps?: InputHTMLAttributes<HTMLTextAreaElement> & { 'data-sel': string }
  expanded?: boolean
  isExpandable?: boolean
  onExpand?: () => void
  onCollapse?: () => void
  title?: string
  titleClassNames?: string
}

export const TextArea = ({
  name,
  disabled,
  className,
  placeholder,
  inputProps,
  title,
  titleClassNames
}: TextAreaProps) => {
  const { register, formState, getFieldState } = useFormContext()
  const { isValidating } = formState
  const { error, isTouched } = getFieldState(name, formState)

  const displayError = error?.message as string

  return (
    <>
      {title && (
        <span className={cx('TextArea__title', titleClassNames)}>{title}</span>
      )}
      <textarea
        className={cx(
          'TextArea',
          displayError ? 'f-c-bo-war f-m-b-010' : 'f-m-b-020',
          disabled && 'FormText--disabled',
          isValidating && 'is-validating',
          isTouched && !displayError && 'f-c-bo-suc400',
          className
        )}
        maxLength={5000}
        placeholder={placeholder}
        {...register(name)}
        {...inputProps}
      />
      {displayError && <FormErrorMessage>{displayError}</FormErrorMessage>}
    </>
  )
}
